import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActionType, AppointmentType, InteractionType, LocalService, PageKey, Status, SummaryType, TriggeredEvent, Wrappers15 } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { DelivererConfigComponent } from '../../popups/deliverer-config/deliverer-config.component';
import { EditAppointmentComponent } from '../../popups/edit-appointment/edit-appointment.component';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss']
})
export class AppointmentsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["appointments"];
  ctryCode: string = ''; businessId: string = ''; appointmentType: AppointmentType; source: Wrappers15; maxBodyHeight = 0;
  isShowExpired = false; customerId = ''; providerId = ''; relationShipType = InteractionType.None; interactionType: InteractionType;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.AppointmentsBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.AppointmentsServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.Appointments);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.setAppointmentType();
        this.relationShipType = this.appointmentType == AppointmentType.ServiceProvider ? InteractionType.ServiceProvider : InteractionType.Business;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.appointmentType == AppointmentType.None || this.businessId != '0') {
      this.sellerManagementService.getAppointments(this.source ? this.source.paging : null, this.businessId, this.isShowExpired, this.customerId, this.providerId).subscribe(result => {
        this.source = result;
      });
    }
  }

  onOpenAppointment(id = '') {
    const modalRef = this.modalService.open(EditAppointmentComponent, { size: 'sm' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.businessId = this.businessId;
    modalRef.componentInstance.appointmentType = this.appointmentType;
    modalRef.componentInstance.interactionType = this.interactionType;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.onLoad();
      }
    });
  }

  onOpenServiceProvider() {
    const modalRef = this.modalService.open(DelivererConfigComponent);
    modalRef.componentInstance.userId = this.localService.basicParams.userId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.router.navigate(['/appointments' + this.localService.basicParamsString, this.businessId]);
      }
    });
  }

  onActionOnAppointment(strKey, actionType: ActionType) {
    this.sellerManagementService.actionOnAppointment(strKey, actionType).subscribe(result => {
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == strKey);
        switch (actionType) {
          case ActionType.Cancel: {
            item.v3 = "1";
          } break;
          case ActionType.ApprovedByCustomer: {
            item.v1 = "1";
          } break;
          case ActionType.ApprovedByProvider: {
            item.v2 = "1";
          } break;
        }
      }
    });
  }

  onUserUpdated(data, index) {
    switch (index) {
      case 1: {
        this.customerId = data;
      } break;
      case 2: {
        this.providerId = data;
      } break;
    }
    this.onLoad();
  }

  setAppointmentType() {
    this.appointmentType = AppointmentType.None;
    switch (this.localService.basicParams.interactionType) {
      case InteractionType.User: {
        this.appointmentType = AppointmentType.None;
      } break;
      case InteractionType.Business: {
        this.appointmentType = AppointmentType.Business;
      } break;
      case InteractionType.ServiceProvider: {
        this.appointmentType = AppointmentType.ServiceProvider;
      } break;
    }
  }

  onGetSummaryType(iAppointmentType): SummaryType {
    let summaryType = SummaryType.User;
    let appointmentType = parseInt(iAppointmentType);
    switch (appointmentType) {
      case AppointmentType.Business: {
        summaryType = SummaryType.Business;
      } break;
      case AppointmentType.ServiceProvider: {
        summaryType = SummaryType.ServiceProvider;
      } break;
      case AppointmentType.Receipt: {
        summaryType = SummaryType.Receipt;
      } break;
    }
    return summaryType;
  }

  onGetIcon(iAppointmentType): string {
    let summaryType = this.onGetSummaryType(iAppointmentType);
    let iconName = '';
    switch (summaryType) {
      case SummaryType.User: {
        iconName = 'person';
      } break;
      case SummaryType.Business: {
        iconName = 'domain';
      } break;
      case SummaryType.ServiceProvider: {
        iconName = 'home_repair_service';
      } break;
      case SummaryType.Receipt: {
        iconName = 'receipt_long';
      } break;
    }
    return iconName;
  }

  onAction(iAppointmentType, businessOrUserId, childBusinessId = '') {
    let summaryType = this.onGetSummaryType(iAppointmentType);
    switch (summaryType) {
      case SummaryType.Receipt: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, businessOrUserId, childBusinessId]);
      } break;
      default: {
        this.localService.showSummary(businessOrUserId, summaryType);
      } break;
    }
  }
}
